import { render, staticRenderFns } from "./AddWhyChooseUs.vue?vue&type=template&id=7d88bcb6&scoped=true&"
import script from "./AddWhyChooseUs.vue?vue&type=script&lang=js&"
export * from "./AddWhyChooseUs.vue?vue&type=script&lang=js&"
import style0 from "./AddWhyChooseUs.vue?vue&type=style&index=0&id=7d88bcb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d88bcb6",
  null
  
)

export default component.exports